$(document).ready(function(){
  var current_page = 1;
  var per_page = 12;
  var collection_id = '89601343569';
  var sort_by = 'featured'
  var show_loadmore_btn = true;

  var form_product_inquiry = {
    form_id: '#formProductInquiry',
    hs_portal_id: '26227935',
    hs_form_guid: '203e7c7a-de79-43f4-ae46-f3e2ecc9eae4',
    redirect_url: 'https://bathspacapital.com/pages/thank-you'
  };

  var form_callback = {
    form_id: '#formCallback',
    hs_portal_id: '26227935',
    hs_form_guid: '35a56d59-178b-4cbc-8bfb-daa5d3896ea4',
    redirect_url: 'https://bathspacapital.com/pages/thank-you'
  };

  // var form_callback_p = {
  //   form_id: '#formProductCallback',
  //   hs_portal_id: '26227935',
  //   hs_form_guid: '35a56d59-178b-4cbc-8bfb-daa5d3896ea4',
  //   redirect_url: 'https://bathspacapital.com/pages/thank-you'
  // };

  var form_receive_modal = {
    form_id: '#formReceiveModal',
    hs_portal_id: '26227935',
    hs_form_guid: 'd735631d-fdca-4713-89b5-12ad96dc689d',
    redirect_url: 'https://bathspacapital.com/pages/thank-you'
  };

  $('#modalProductInquiry').appendTo("body");
  $('#modalFormReceiveGuide').appendTo("body");

  loadProducts(current_page, []);
  initializeForm(form_product_inquiry, 'product');
  initializeForm(form_callback, 'callback');
  // initializeForm(form_callback_p, 'callback');
  initializeForm(form_receive_modal, 'default');

  jQuery(document).on('click', '.lp-product--inquiry', function () {
    var product_id     = jQuery(this).data('product-id');
    var product_name   = jQuery(this).data('product-name');
    var product_vendor = jQuery(this).data('product-vendor');
    var product_image  = jQuery(this).data('product-image'); 

    jQuery('#modalProductInquiry').find('#productName').val(product_name);
    jQuery('#modalProductInquiry').find('#mdProductName').text(product_name);
    jQuery('#modalProductInquiry').find('#mdProductVendor').text(product_vendor);
    jQuery('#modalProductInquiry').find('#mdProductImage').html('<img src="'+product_image+'" alt="product_'+ product_id+'" class="img-fluid" />');
  });

  jQuery(document).on('click', '.filter-vendor', function() {
    var selected_vendors = [];
    $("input:checkbox[name=filter_by_vendor]:checked").each(function() {
      selected_vendors.push($(this).val());
    });

    loadProducts(1, selected_vendors);
  });

  jQuery(document).on('click', '#load-more', function() {
    current_page++;
    var selected_vendors = [];

    if (show_loadmore_btn) {
      show_loadmore_btn = false;
      jQuery('#load-more').css('visibility', 'hidden');
    }

    $("input:checkbox[name=filter_by_vendor]:checked").each(function() {
      selected_vendors.push($(this).val());
    });

    loadProducts(current_page, selected_vendors);
  });

  jQuery.validator.addMethod("validate_email", function(value, element) {
    if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) {
      return true;
    } else {
      return false;
    }
  }, "Please enter a valid email address.");

  function loadProducts(page, selected_vendors) {
    $('.product-list-wrapper').addClass('product-list-wrapper--is-loading');

    $.getJSON('/collections/gold-coinage/products.json?collection_id=89601343569&sort_by=' + sort_by + '&limit=' + per_page + '&page=' + page, function(data) {
      var product_list = $("#productListContainer");
      var fproducts;
      var fproducts_count;

      if (selected_vendors.length > 0) {
        var products = data.products;
        fproducts = products.filter(function(product) {
          return selected_vendors.includes( convertToSlug(product.vendor) );
        });
        fproducts_count = fproducts.length;
      } else {
        fproducts = data.products;
        fproducts_count = fproducts.length;
      }

      if (page == 1) {
        product_list.html('');
      }

      // console.log(`Current page is ${page}`);
      // console.log(`Total products is ${fproducts_count}`);

      for (var i = 0; i < fproducts.length; i++) {
        var product = fproducts[i];
        var product_id = product.id;
        var product_image_featured = product.images[0].src.replace('.jpg', '_medium.jpg');
        var product_image_modal = product.images[0].src.replace('.jpg', '_large.jpg');
        var product_title = product.title;
        var product_vendor = product.vendor;

        var productHtml = `<div class="col-6 col-md-4 col-lg-3 mb-4 lp-product--gold">
          <div class="lp-product">
            <div class="text-center">
              <img src='${product_image_featured}' class="img-fluid lp-product__image" />
            </div>
            <p class="lp-product__title">${product_title}</p>
            <a 
              href="#"
              class="btn btn-outline-warning lp-product--inquiry lp-product__action"
              data-bs-toggle="modal"
              data-bs-target="#modalProductInquiry"
              data-product-id='${product_id}'
              data-product-image='${product_image_modal}'
              data-product-name='${product_title}'
              data-product-vendor='${product_vendor}'
            >
              Contact us for request to source
            </a>
          </div>
        </div>`;

        product_list.append(productHtml).fadeIn(1000);
      }

      if (fproducts_count == 0) {
        $('#productListContainer').html('');
        $('#productCallbackContainer').show();
        $('#load-more').hide();
      } else if (fproducts_count <= 1) {
        $('#load-more').text('No more products');
        $('#load-more').attr('disabled', 'disabled');
        $('#load-more').show();
        $('#productCallbackContainer').hide();
      } else {
        $('#load-more').text('Load More');
        $('#load-more').removeAttr('disabled', 'disabled');
        $('#load-more').show();
        $('#productCallbackContainer').hide();
      }

    });

    setTimeout(function(){
      jQuery('#load-more').css('visibility', 'visible');
      $('.product-list-wrapper').removeClass('product-list-wrapper--is-loading');
    }, 1000);
  }

  function convertToSlug(Text) {
    return Text.toLowerCase()
              .replace(/[^\w ]+/g, '')
              .replace(/ +/g, '-');
  }

  function initializeForm(cform, type) {

    if (type == 'default') {
      $( cform.form_id ).validate({
        rules: {
          FirstName: {
            required: true
          },
          LastName: {
            required: true
          },
          PhoneNumber: {
            required: true,
            number: true,
            // Enable when api is added
            d8val_inttelephone: [
              {
                name: "AllowedPrefixes",
                value: "+44"
              }
            ]
          },
          EmailAddress: {
            required: true,
            validate_email: true
          },
          agreeCheck: {
            required: true
          }
        },
        submitHandler: function(form) {
          var formStepOne = {
            'fields': [
              {
                'name': 'firstname',
                'value':  $( cform.form_id + ' input[name="FirstName"]').val()
              },
              {
                'name': 'lastname',
                'value':  $( cform.form_id + ' input[name="LastName"]').val()
              },
              {
                'name': 'phone',
                'value':  $( cform.form_id + ' input[name="PhoneNumber"]').val()
              },
              {
                'name': 'email',
                'value':  $( cform.form_id + ' input[name="EmailAddress"]').val()
              },
            ],
            'context': {
              // 'hutk': hscookie,
              'pageUri': window.location.href,
              'pageName': 'Gold Coins - Bath Spa Capital'
            }
          };
          
          $.ajax({
            url: 'https://api.hsforms.com/submissions/v3/integration/submit/'+ cform.hs_portal_id + '/' + cform.hs_form_guid,
            type: 'POST',
            contentType: "application/json",
            dataType: "json",
            headers: {
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*'
            },
            data: JSON.stringify(formStepOne),
            beforeSend: function () {
              $(form).find('input[type="submit"]').attr('disabled', true);
            },
            success: function(response) {
              window.location.href = cform.redirect_url;
            },
            complete: function() {
              $(form).find('input[type="submit"]').attr('disabled', false);
            },
            error: function (status, error) {
              // console.log(error, status);
            }
          });
        }
      });
    }

    if (type == 'product') {
      $( cform.form_id ).validate({
        rules: {
          FirstName: {
            required: true
          },
          LastName: {
            required: true
          },
          PhoneNumber: {
            required: true,
            number: true,
            // Enable when api is added
            d8val_inttelephone: [
              {
                name: "AllowedPrefixes",
                value: "+44"
              }
            ]
          },
          EmailAddress: {
            required: true,
            validate_email: true
          },
          agreeCheck: {
            required: true
          }
        },
        submitHandler: function(form) {
          var formStepOne = {
            'fields': [
              {
                'name': 'firstname',
                'value':  $( cform.form_id + ' input[name="FirstName"]').val()
              },
              {
                'name': 'lastname',
                'value':  $( cform.form_id + ' input[name="LastName"]').val()
              },
              {
                'name': 'phone',
                'value':  $( cform.form_id + ' input[name="PhoneNumber"]').val()
              },
              {
                'name': 'email',
                'value':  $( cform.form_id + ' input[name="EmailAddress"]').val()
              },
              {
                'name': 'product_inq',
                'value':  $( cform.form_id + ' input[name="ProductName"]').val()
              },
            ],
            'context': {
              // 'hutk': hscookie,
              'pageUri': window.location.href,
              'pageName': 'Gold Coins - Bath Spa Capital'
            }
          };
          
          $.ajax({
            url: 'https://api.hsforms.com/submissions/v3/integration/submit/'+ cform.hs_portal_id + '/' + cform.hs_form_guid,
            type: 'POST',
            contentType: "application/json",
            dataType: "json",
            headers: {
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*'
            },
            data: JSON.stringify(formStepOne),
            beforeSend: function () {
              $(form).find('input[type="submit"]').attr('disabled', true);
            },
            success: function(response) {
              window.location.href = cform.redirect_url;
            },
            complete: function() {
              $(form).find('input[type="submit"]').attr('disabled', false);
            },
            error: function (status, error) {
              // console.log(error, status);
            }
          });
        }
      });
    }
  
    if (type == 'callback') {
      $( cform.form_id ).validate({
        rules: {
          FirstName: {
            required: true
          },
          LastName: {
            required: true
          },
          PhoneNumber: {
            required: true,
            number: true,
            // Enable when api is added
            d8val_inttelephone: [
              {
                name: "AllowedPrefixes",
                value: "+44"
              }
            ]
          },
        },
        submitHandler: function(form) {
          var formStepOne = {
            'fields': [
              {
                'name': 'firstname',
                'value':  $( cform.form_id + ' input[name="FirstName"]').val()
              },
              {
                'name': 'lastname',
                'value':  $( cform.form_id + ' input[name="LastName"]').val()
              },
              {
                'name': 'phone',
                'value':  $( cform.form_id + ' input[name="PhoneNumber"]').val()
              },
            ],
            'context': {
              // 'hutk': hscookie,
              'pageUri': window.location.href,
              'pageName': 'Gold Coins - Bath Spa Capital'
            }
          };
          
          $.ajax({
            url: 'https://api.hsforms.com/submissions/v3/integration/submit/'+ cform.hs_portal_id + '/' + cform.hs_form_guid,
            type: 'POST',
            contentType: "application/json",
            dataType: "json",
            headers: {
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*'
            },
            data: JSON.stringify(formStepOne),
            beforeSend: function () {
              $(form).find('input[type="submit"]').attr('disabled', true);
            },
            success: function(response) {
              window.location.href = cform.redirect_url;
            },
            complete: function() {
              $(form).find('input[type="submit"]').attr('disabled', false);
            },
            error: function (status, error) {
              // console.log(error, status);
            }
          });
        }
      });
    }
  
  }

});
